import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree
} from "vuex";
import { RootState } from "../store";
import {
  CourseTrack,
  CourseTrackMandatory
} from "../../../../domain/entities/entities";
import { InterfaceCourseTrackUseCases } from "../../../../domain/usecase/impl/courseTrackUseCases";
import { Order } from "../../../../domain/entities/order";

class CourseTrackState {
  requiredCourseTrack: CourseTrack[] = [];
  courseTrackMandatory: CourseTrackMandatory = new CourseTrackMandatory();
}

const state = new CourseTrackState();

const mutations: MutationTree<CourseTrackState> = {
  SET_TRAININGS_COURSE_TRACK(
    state: CourseTrackState,
    courseTrackMandatory: CourseTrackMandatory
  ) {
    for (let training of courseTrackMandatory.course) {
      state.courseTrackMandatory.course.push(training);
    }

    state.courseTrackMandatory.haveTrainingInTrack =
      courseTrackMandatory.haveTrainingInTrack;
  },
  SET_REQUIRED_COURSE_TRACK(
    state: CourseTrackState,
    requiredCourseTrack: CourseTrack[]
  ): void {
    state.requiredCourseTrack = requiredCourseTrack;
  },
  SET_CLEAR_MANDATORY_COURSETRACK(state: CourseTrackState): void {
    state.courseTrackMandatory = new CourseTrackMandatory([], false);
  }
};

const actions: ActionTree<CourseTrackState, RootState> = {
  async listCourseTrackTraining(
    { commit }: ActionContext<CourseTrackState, RootState>,
    payload: { courseTrackID: number; index: number }
  ): Promise<void> {
    try {
      const response: CourseTrackMandatory = await InterfaceCourseTrackUseCases.listCourseTrackTraining(
        payload.courseTrackID,
        payload.index
      );

      await commit("SET_TRAININGS_COURSE_TRACK", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async getRequiredCourseTrack(
    { commit }: ActionContext<CourseTrackState, RootState>,
    order: Order
  ): Promise<void> {
    try {
      const response: CourseTrack[] = await InterfaceCourseTrackUseCases.getRequiredCourseTrack(
        order
      );
      commit("SET_REQUIRED_COURSE_TRACK", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async cleanMandatoryCourseTrackState({
    commit
  }: ActionContext<CourseTrackState, RootState>): Promise<void> {
    try {
      commit("SET_CLEAR_MANDATORY_COURSETRACK");
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
};

const getters: GetterTree<CourseTrackState, RootState> = {
  courseTrackMandatory: (state: CourseTrackState): CourseTrackMandatory =>
    state.courseTrackMandatory,
  requiredCourseTrack: (state: CourseTrackState): CourseTrack[] =>
    state.requiredCourseTrack
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<CourseTrackState, RootState>;
